/**
 * @vitest-environment jsdom
 */

import { describe, expect, beforeEach, it, vi } from "vitest";
import posthog from "posthog-js";

import { initPosthog } from "./posthog";

vi.mock("posthog-js", () => ({
  default: {
    init: vi.fn(),
  },
}));

describe("initPosthog", () => {
  beforeEach(() => {
    vi.clearAllMocks();
  });

  it("does not initialize without an API key", () => {
    initPosthog("", "https://app.posthog.com");
    expect(posthog.init).not.toHaveBeenCalled();
  });

  it("initializes with session recording disabled", () => {
    initPosthog("phc_test", "https://app.posthog.com");

    expect(posthog.init).toHaveBeenCalledWith("phc_test", {
      api_host: "https://app.posthog.com",
      capture_pageview: false,
      disable_session_recording: true,
    });
  });
});
